<script>
import { mapState } from "vuex";
import umatOpt from "@/data/umatOpt";
import umatData from "@/data/umat";
// import pekerjaanList from "@/data/pekerjaan";

export default {
	name: "compUmatDetail",
	data() {
		return {
			myOptions: {
				kriteria: umatOpt.kriteria,
				paroki: umatData.paroki,
				keuskupan: umatData.keuskupan,
			},
		};
	},
	mounted() {
		// this.$validator.validateAll();
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			umatItem: (state) => state.umat.item,
		}),

		arrayToString() {
			return (value) => (value ? value.join(", ") : "");
		},
		getJK() {
			return (jk) => (jk === "L" ? "Laki-laki" : "Perempuan");
		},
	},
	methods: {},
};
</script>

<template>
	<div class="row text-left">
		<div class="col-md-6">
			<table class="table table-striped">
				<tbody>
					<tr>
						<td>Nama Lengkap</td>
						<td>:</td>
						<td>{{ umatItem.nama }}</td>
					</tr>
					<tr>
						<td>Jenis Kelamin</td>
						<td>:</td>
						<td>{{ getJK(umatItem.jk) }}</td>
					</tr>
					<tr>
						<td>Tempat Tanggal Lahir</td>
						<td>:</td>
						<td>
							{{ umatItem.tempat_lahir }}
							{{ $moment(umatItem.tgl_lahir).format("DD MMMM YYYY") }}
						</td>
					</tr>
					<tr>
						<td>Umur</td>
						<td>:</td>
						<td>
							{{ $moment().diff(umatItem.tgl_lahir, "years") }} Tahun
						</td>
					</tr>
					<tr>
						<td>Gol. Darah</td>
						<td>:</td>
						<td>{{ umatItem.gol_darah }}</td>
					</tr>

					<tr>
						<td>Agama</td>
						<td>:</td>
						<td>{{ umatItem.agama }}</td>
					</tr>
					<tr>
						<td>Status Pernikahan</td>
						<td>:</td>
						<td>{{ umatItem.status_kawin }}</td>
					</tr>
					<tr>
						<td>NIK</td>
						<td>:</td>
						<td>{{ umatItem.nik }}</td>
					</tr>
					<tr>
						<td>No. HP</td>
						<td>:</td>
						<td>{{ umatItem.nohp }}</td>
					</tr>
					<tr>
						<td>Email</td>
						<td>:</td>
						<td>{{ umatItem.email }}</td>
					</tr>
					<tr>
						<td>Wilayah/Keuskupan</td>
						<td>:</td>
						<td>{{ umatItem.keuskupan }}</td>
					</tr>
					<tr>
						<td>Paroki</td>
						<td>:</td>
						<td>{{ umatItem.paroki }}</td>
					</tr>
					<tr>
						<td>Lingkungan/Stasi</td>
						<td>:</td>
						<td>
							{{ umatItem.lingkungan_stasi }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="col-md-6">
			<table class="table table-striped">
				<tbody>
					<tr>
						<td>Nama Ayah</td>
						<td>:</td>
						<td>{{ umatItem.ayah }}</td>
					</tr>
					<tr>
						<td>Nama Ibu</td>
						<td>:</td>
						<td>{{ umatItem.ibu }}</td>
					</tr>
					<tr>
						<td>Aktivitas Sosial</td>
						<td>:</td>
						<td>{{ umatItem.aktivitas }}</td>
					</tr>
					<tr>
						<td>Pendidikan</td>
						<td>:</td>
						<td>{{ umatItem.pendidikan }}</td>
					</tr>
					<tr>
						<td>Jurusan</td>
						<td>:</td>
						<td>{{ umatItem.jurusan }}</td>
					</tr>
					<tr>
						<td>Pekerjaan</td>
						<td>:</td>
						<td>{{ umatItem.pekerjaan }}</td>
					</tr>
					<tr>
						<td>Profesi</td>
						<td>:</td>
						<td>
							{{ arrayToString(umatItem.profesi) }}
						</td>
					</tr>
					<tr>
						<td>Keterampilan</td>
						<td>:</td>
						<td>
							{{ arrayToString(umatItem.keterampilan) }}
						</td>
					</tr>
					<tr>
						<td>Alamat</td>
						<td>:</td>
						<td>{{ umatItem.alamat }}</td>
					</tr>
					<tr>
						<td>Kota/Kabupaten</td>
						<td>:</td>
						<td>{{ umatItem.kabupaten }}</td>
					</tr>
					<tr>
						<td>Kecamatan</td>
						<td>:</td>
						<td>{{ umatItem.kecamatan }}</td>
					</tr>
					<tr>
						<td>Kelurahan/Desa</td>
						<td>:</td>
						<td>{{ umatItem.desa }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

